"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeResetTradePwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var GetDynamicCodeResetTradePwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetDynamicCodeResetTradePwd, _super);
    function GetDynamicCodeResetTradePwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '重置交易密码发送验证码接口';
        _this.code = '101069';
        _this.desc = '重置交易密码发送验证码接口';
        _this.requestParams = new dynamicCode_1.GetDynamicCodeResetTradePwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetDynamicCodeResetTradePwd;
}(service_1.BaseService));
exports.GetDynamicCodeResetTradePwd = GetDynamicCodeResetTradePwd;
//# sourceMappingURL=getDynamicCodeResetTradePwd.js.map